import { Action } from '@ngrx/store';
import { Hanger } from '@app/models';

export enum HangerActionTypes {
  Load = '[API] Load hangers',
  LoadSuccess = '[API] Load hangers success',
  LoadFail = '[API] Load hangers fail',

  AddAll = '[Hanger] Add all',
  AddOne = '[Hanger] Add one',

  Create = '[API] Create hanger',
  CreateSuccess = '[API] Create hanger success',
  CreateFail = '[API] Create hanger fail',

  UpdateHanger = '[API] Update hanger',
  UpdateHangerSuccess = '[Hanger] Update hanger success',
  UpdateFail = '[Hanger] Update hanger fail',
  UpdateHangerOne = '[Hanger] Update hanger one',

  DeleteHanger = '[Hanger] delete hanger',
  DeleteHangerSuccess = '[Hanger] delete hanger success',
  DeleteHangerFail = '[Hanger] delete hanger fail'
}

export class Load implements Action {
  readonly type = HangerActionTypes.Load;
  constructor(public FollowId?: number) {}
}

export class LoadSuccess implements Action {
  readonly type = HangerActionTypes.LoadSuccess;
  constructor(public hangers: Hanger[]) {}
}

export class LoadFail implements Action {
  readonly type = HangerActionTypes.LoadFail;
  constructor(public error: any) {}
}

export class AddAll implements Action {
  readonly type = HangerActionTypes.AddAll;
  constructor(public hangers: Hanger[]) {}
}

export class AddOne implements Action {
  readonly type = HangerActionTypes.AddOne;
  constructor(public hanger: Hanger) {}
}

export class Create implements Action {
  readonly type = HangerActionTypes.Create;
  constructor(public hanger: Hanger) {}
}

export class CreateSuccess implements Action {
  readonly type = HangerActionTypes.CreateSuccess;
  constructor(public hanger: Hanger) {}
}

export class CreateFail implements Action {
  readonly type = HangerActionTypes.CreateFail;
  constructor(public error: any) {}
}

export class UpdateHanger implements Action {
  readonly type = HangerActionTypes.UpdateHanger;
  constructor(public id: number, public hanger: any) {}
}

export class UpdateFail implements Action {
  readonly type = HangerActionTypes.UpdateFail;
  constructor(public error: any) {}
}

export class UpdateHangerSuccess implements Action {
  readonly type = HangerActionTypes.UpdateHangerSuccess;
  constructor(public id: number, public data: any) {}
}

export class UpdateHangerOne implements Action {
  readonly type = HangerActionTypes.UpdateHangerOne;
  constructor(public hanger: Hanger) {}
}

export class DeleteHanger implements Action {
  readonly type = HangerActionTypes.DeleteHanger;
  constructor(public hangerId: number) {}
}

export class DeleteHangerSuccess implements Action {
  readonly type = HangerActionTypes.DeleteHangerSuccess;
  constructor(public data?: any) {}
}

export class DeleteHangerFail implements Action {
  readonly type = HangerActionTypes.DeleteHangerFail;
  constructor(public error: any) {}
}

export type HangerActionsUnion =
  | Load
  | LoadFail
  | LoadSuccess
  | AddAll
  | AddOne
  | Create
  | CreateSuccess
  | CreateFail
  | UpdateHanger
  | UpdateHangerSuccess
  | UpdateFail
  | UpdateHangerOne
  | DeleteHanger
  | DeleteHangerSuccess
  | DeleteHangerFail;
